import React from 'react'
import styled, { useTheme } from 'styled-components'
import { SpaceProps } from 'styled-system'
import { useMediaQuery } from '@mui/material'
import { MprolabSmall } from '../Svg'
import { Text, TextVariant } from '../Text'
import { Flex } from '../Flex'
import { Button } from '../Button'

export interface CallToActionProps extends SpaceProps {
  onButtonClick?: () => void
  buttonTitle: string
  headerTitle: string
  infoText: string
  buttonEndIcon?: React.ReactNode
}

const BrandIconWrapper = styled(Flex)`
  border-radius: 16px;
  background-color: '#101723';
  padding: 8px;
  border-radius: 14px;
  aspect-ratio: 1 / 1;
`

const CallToActionComponent: React.FC<CallToActionProps> = ({
  onButtonClick,
  buttonTitle,
  headerTitle,
  infoText,
  buttonEndIcon,
  ...props
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.mediaQueries.mobile)

  return (
    <Flex
      p="18px 24px"
      borderRadius="16px"
      width="100%"
      marginTop={32}
      background="#141E2F"
      alignItems={isMobile ? 'flex-start' : 'center'}
      flexDirection={isMobile ? 'column' : 'row'}
      justifyContent="space-between"
      {...props}
    >
      <Flex alignItems="center" flexDirection={isMobile ? 'column' : 'row'} width={isMobile ? '100%' : 'fit-content'}>
        <BrandIconWrapper justifyContent="center" alignItems="center" mr={isMobile ? '0' : '14px'}>
          <MprolabSmall />
        </BrandIconWrapper>
        <Flex flexDirection="column" justifyContent="center" mr={isMobile ? '0' : '24px'}>
          <Text
            variant={TextVariant.BODY_DEFAULT_BOLD}
            mt={isMobile ? '16px' : '0'}
            textAlign={isMobile ? 'center' : 'initial'}
          >
            {headerTitle}
          </Text>
          <Text
            color="#8197BB"
            variant={TextVariant.BODY_SMALL}
            textAlign={isMobile ? 'center' : 'initial'}
            style={{ whiteSpace: 'nowrap' }}
          >
            {infoText}
          </Text>
        </Flex>
      </Flex>
      <Flex width="109px" justifyContent="center" fullWidth>
        <Button
          size="sm"
          fullWidth={isMobile}
          marginTop={isMobile ? '16px' : 0}
          onClick={onButtonClick}
          endIcon={buttonEndIcon}
        >
          {buttonTitle}
        </Button>
      </Flex>
    </Flex>
  )
}

export default CallToActionComponent
